import countries from "somecountries/data.json";

export function getCountryName(item) {
  let name = item.names.short.en;
  if (item.names.abbreviation.en) {
    name += " (" + item.names.abbreviation.en[0] + ")";
  }

  return name;
}

export const countryNames = countries.map(getCountryName);

countryNames.sort();

export { countries };
